module.exports = __webpack_public_path__ + "static/media/womanvr.e8e23799.jpg";